import { FieldType, FilterFormDataModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';

export class FilterFormData {
  static FORM_DATA: FilterFormDataModel = {
    title: 'Asset',
    description: '',
    customClient: CustomClients.WestLotto,
    formFields: [
      {
        formTypeId: '20',
        formFieldName: 'assetType-label',
        fieldLabel: $localize`Asset type`,
        fieldType: FieldType.Label,
        placeholder: '',
        visible: true,
        widthClass: WidthClass.W12,
      },
      {
        formTypeId: '21',
        formFieldName: 'duration-label',
        fieldLabel: $localize`Duration` + ' (' + $localize`From` + ' - ' + $localize`Until` + ')',
        fieldType: FieldType.Label,
        placeholder: '',
        visible: true,
        widthClass: WidthClass.W12,
      },
      {
        formTypeId: '1',
        formFieldName: 'assetType',
        fieldType: FieldType.Dropdown,
        fieldLabel: '',
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        multiple: true,
        options: [],
        hideLabel: true,
      },

      {
        formTypeId: '2',
        formFieldName: 'duration_from',
        fieldType: FieldType.Duration,
        fieldLabel: '',
        placeholder: 'hh:mm:ss',
        inputType: '',
        mandatory: false,
        regex: '^[0-9:]*$',
        validationRegex: '^[0-9:]*$',
        widthClass: WidthClass.W14,
        disable: false,
        visible: true,
      },
      {
        formTypeId: '3',
        formFieldName: 'duration_to',
        fieldType: FieldType.Duration,
        fieldLabel: '',
        placeholder: 'hh:mm:ss',
        inputType: '',
        mandatory: false,
        regex: '^[0-9:]*$',
        validationRegex: '^[0-9:]*$',
        widthClass: WidthClass.W14,
        disable: false,
        visible: true,
      },
      {
        formTypeId: '4',
        formFieldName: 'formatType',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Format`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        multiple: true,
        options: [],
      },
      {
        formTypeId: '5',
        formFieldName: 'mediumType',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Medium`,
        placeholder: $localize`:placeholder:-- All Medium --`,
        inputType: '',
        mandatory: false,
        validationRegex: '',
        widthClass: WidthClass.W12,
        subProjectFlag: false,
        disable: false,
        visible: true,
        multiple: true,
        options: [],
      },
    ],
  };
}
